import gql from 'graphql-tag';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The javascript `Date` as string. Type represents date and time as the ISO Date string. */
  DateTime: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
};



export type AccountConfigEntity = CoreBaseEntity & {
  __typename?: 'AccountConfigEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  accessTokenDuration: Scalars['String'];
  refreshTokenDuration: Scalars['String'];
  accountId: Scalars['String'];
  pwdchangefrequency: Scalars['Float'];
  repeatPwd: Scalars['Float'];
};

export type AccountDebtor = {
  __typename?: 'AccountDebtor';
  accountId?: Maybe<Scalars['String']>;
  lDebtorId?: Maybe<Scalars['Float']>;
  propertyName?: Maybe<Scalars['String']>;
  debtorAccountName?: Maybe<Scalars['String']>;
  contractLotNo?: Maybe<Scalars['String']>;
};

export type AccountDeleteInput = {
  ID: Scalars['String'];
};

export type AccountEntity = CoreBaseEntity & {
  __typename?: 'AccountEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  name: Scalars['String'];
  code?: Maybe<Scalars['String']>;
  regNo?: Maybe<Scalars['String']>;
  contactNo?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  currencyId?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['JSON']>;
  contactPerson?: Maybe<Scalars['JSON']>;
  user?: Maybe<Array<UserAccSoftwareEntity>>;
  newsFeed: Array<NewsFeedEntity>;
  serviceRequests?: Maybe<Array<ServiceRequest>>;
  roles?: Maybe<Array<RoleEntity>>;
  roleUsers?: Maybe<Array<RoleUserEntity>>;
  sNumberFormats?: Maybe<Array<SNumberFormat>>;
  subscription: Array<SubscriptionEntity>;
  termsConditions: Array<TermsConditionsEntity>;
  bankAccount: Array<FromBankAccountEntity>;
  accountSettings: Array<SAccountSettings>;
  paymentTransactions?: Maybe<Array<SPaymentTransaction>>;
  currency?: Maybe<CurrencyEntity>;
  gatewayVersion?: Maybe<Scalars['String']>;
};


export type AccountEntityNewsFeedArgs = {
  IsFindLatestPostDate?: Maybe<Scalars['Boolean']>;
};

export type AccountInput = {
  ID?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  code: Scalars['String'];
  email: Scalars['String'];
  regNo: Scalars['String'];
  contactNo: Scalars['String'];
  address?: Maybe<AddressInput>;
  contactPerson?: Maybe<ContactPersonInput>;
  currencyId?: Maybe<Scalars['String']>;
  commonStatus?: Maybe<CommonStatus>;
};

export type AccountOutput = {
  __typename?: 'AccountOutput';
  accountId?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  ID?: Maybe<Scalars['String']>;
};

export type ActiveRentalContract = {
  __typename?: 'ActiveRentalContract';
  IsHasGTO?: Maybe<Scalars['Boolean']>;
};

export type Address = {
  __typename?: 'Address';
  siteName?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  postCode?: Maybe<Scalars['String']>;
  AddressType?: Maybe<AddressType>;
};

export type AddressInput = {
  siteName?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  postCode?: Maybe<Scalars['String']>;
  AddressType?: Maybe<AddressType>;
};

export enum AddressType {
  Primary = 'PRIMARY',
  Delivery = 'DELIVERY',
  Site = 'SITE'
}

export type AttachmentData = {
  __typename?: 'AttachmentData';
  content: Scalars['String'];
  filename: Scalars['String'];
};

export type AttachmentEntity = CoreBaseEntity & {
  __typename?: 'AttachmentEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  accountId: Scalars['String'];
  softwareId: Scalars['String'];
  refTable?: Maybe<Scalars['String']>;
  refType?: Maybe<Scalars['String']>;
  refId?: Maybe<Scalars['String']>;
  mediaType: Scalars['String'];
  resourceUrl?: Maybe<Scalars['String']>;
  fileName: Scalars['String'];
  bucketFileName?: Maybe<Scalars['String']>;
  isPrivate?: Maybe<Scalars['Boolean']>;
  commonStatus: CommonStatus;
  fileSize: Scalars['Float'];
  requestActivity: RequestActivity;
  requestFollowUp: RequestFollowUp;
  requestEstimation: RequestEstimation;
  newsFeed?: Maybe<NewsFeedEntity>;
  account: AccountEntity;
};

export type AuditEntity = {
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
};

export type BaseInput = {
  ID?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  commonStatus?: Maybe<CommonStatus>;
};

export type BusinessInsightOutput = {
  __typename?: 'BusinessInsightOutput';
  openCase?: Maybe<Scalars['Float']>;
  resolvedCase?: Maybe<Scalars['Float']>;
  inProgressCase?: Maybe<Scalars['Float']>;
  closedCase?: Maybe<Scalars['Float']>;
  monthText?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

export type CityEntity = CoreBaseEntity & {
  __typename?: 'CityEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  name: Scalars['String'];
  stateId: Scalars['String'];
  commonStatus: CommonStatus;
  state: StateEntity;
  postcode: Array<PostcodeEntity>;
};

export type CityInput = {
  name?: Maybe<Scalars['String']>;
  stateID?: Maybe<Scalars['String']>;
  ID?: Maybe<Scalars['String']>;
};

export type CloudStorageOutput = {
  __typename?: 'CloudStorageOutput';
  BucketFileName: Scalars['String'];
  FileName: Scalars['String'];
  Url: Scalars['String'];
  MediaType: Scalars['String'];
  IsPrivate?: Maybe<Scalars['Boolean']>;
  PrivateUrl?: Maybe<Scalars['String']>;
};

export enum CommonStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Block = 'BLOCK'
}

export type CompanyData = {
  __typename?: 'CompanyData';
  name?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['Float']>;
};

export type ContactPerson = {
  __typename?: 'ContactPerson';
  name?: Maybe<Scalars['String']>;
  designation?: Maybe<Scalars['String']>;
  contactNo?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
};

export type ContactPersonInput = {
  name?: Maybe<Scalars['String']>;
  designation?: Maybe<Scalars['String']>;
  contactNo?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
};

export type CoreBaseEntity = {
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
};

export type CountryEntity = CoreBaseEntity & {
  __typename?: 'CountryEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  name: Scalars['String'];
  code: Scalars['String'];
  commonStatus: CommonStatus;
  state: Array<StateEntity>;
};

export type CountryInput = {
  name?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  ID?: Maybe<Scalars['String']>;
};

export type CreateAuditInput = {
  createdBy?: Maybe<Scalars['String']>;
};

export type CreateTenantUserAndRoleInput = {
  name: Scalars['String'];
  contactNo?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  roleIds?: Maybe<Array<Scalars['String']>>;
};

export type CrossCallOutput = {
  __typename?: 'CrossCallOutput';
  property?: Maybe<PropertyOutput>;
  account?: Maybe<AccountOutput>;
  activeRentalContract?: Maybe<ActiveRentalContract>;
};

export type CurrencyDeleteInput = {
  ID: Scalars['String'];
};

export type CurrencyEntity = CoreBaseEntity & {
  __typename?: 'CurrencyEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  code: Scalars['String'];
  name: Scalars['String'];
  symbol: Scalars['String'];
  commonStatus: CommonStatus;
  account: Array<AccountEntity>;
};

export type CurrencyExchangeEntity = {
  __typename?: 'CurrencyExchangeEntity';
  fromCurrencyId: Scalars['String'];
  toCurrencyId: Scalars['String'];
  effectiveDate: Scalars['DateTime'];
  fromAmt: Scalars['Float'];
  toAmt: Scalars['Float'];
  exchangeRate: Scalars['Float'];
  commonStatus: CommonStatus;
};

export type CurrencyInput = {
  ID?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  symbol?: Maybe<Scalars['String']>;
  commonStatus?: Maybe<CommonStatus>;
};


export type DownloadLogEntity = CoreBaseEntity & {
  __typename?: 'DownloadLogEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  commonStatus: Scalars['String'];
  accountId: Scalars['String'];
  softwareId: Scalars['String'];
  attachmentId?: Maybe<Scalars['String']>;
  fileName: Scalars['String'];
  fileSize: Scalars['Float'];
  modulePath?: Maybe<Scalars['String']>;
  ipAddress?: Maybe<Scalars['String']>;
};

export type EmailBlastArgs = {
  __typename?: 'EmailBlastArgs';
  senderName: Scalars['String'];
  senderEmail: Scalars['String'];
  recipients: Array<Scalars['String']>;
  subject: Scalars['String'];
  message: Scalars['String'];
  isMultiple: Scalars['Boolean'];
  ccEmail?: Maybe<Array<Scalars['String']>>;
  bccEmail?: Maybe<Array<Scalars['String']>>;
  categories?: Maybe<Array<Scalars['String']>>;
  attachments?: Maybe<Array<AttachmentData>>;
  replyTo?: Maybe<Scalars['String']>;
  sentAt?: Maybe<Scalars['Float']>;
};

export type EmailBlastAttachment = {
  content: Scalars['String'];
  filename: Scalars['String'];
};

export type EmailBlastInput = {
  senderName: Scalars['String'];
  recipients: Array<Scalars['String']>;
  subject: Scalars['String'];
  message: Scalars['String'];
  isMultiple: Scalars['Boolean'];
  ccEmail?: Maybe<Array<Scalars['String']>>;
  bccEmail?: Maybe<Array<Scalars['String']>>;
  attachments?: Maybe<Array<EmailBlastAttachment>>;
  categories?: Maybe<Array<Scalars['String']>>;
  replyTo?: Maybe<Scalars['String']>;
  sendAtUnix?: Maybe<Scalars['Float']>;
};

export type EmailBlastLogEntity = CoreBaseEntity & {
  __typename?: 'EmailBlastLogEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  commonStatus: Scalars['String'];
  accountId: Scalars['String'];
  softwareId: Scalars['String'];
  args?: Maybe<Scalars['JSON']>;
  recipientCount: Scalars['Float'];
  errorMsg?: Maybe<Scalars['String']>;
};

export type EntityContol = {
  noOfEntity?: Maybe<Scalars['Float']>;
  noofExtraEntity?: Maybe<Scalars['Float']>;
};

export type FromBankAccountEntity = {
  __typename?: 'FromBankAccountEntity';
  accountId: Scalars['String'];
  name: Scalars['String'];
  accountHolder: Scalars['String'];
  accountNo: Scalars['String'];
  branch: Scalars['String'];
  address: Scalars['JSON'];
  account: AccountEntity;
};

export type FromBankAccountInput = {
  accountHolder: Scalars['String'];
  accountNo: Scalars['String'];
  address: AddressInput;
  accountId: Scalars['String'];
  name: Scalars['String'];
  branch: Scalars['String'];
  ID?: Maybe<Scalars['String']>;
};

export type FromBankDetails = {
  __typename?: 'FromBankDetails';
  name?: Maybe<Scalars['String']>;
  acctHolder?: Maybe<Scalars['String']>;
  acctNo?: Maybe<Scalars['String']>;
  branch?: Maybe<Scalars['String']>;
};

export type FromBankDetailsInput = {
  name?: Maybe<Scalars['String']>;
  acctHolder?: Maybe<Scalars['String']>;
  acctNo?: Maybe<Scalars['String']>;
  branch?: Maybe<Scalars['String']>;
};

export type HuaweiStorageOutput = {
  __typename?: 'HuaweiStorageOutput';
  BucketFileName: Scalars['String'];
  FileName: Scalars['String'];
  Url: Scalars['String'];
  MediaType: Scalars['String'];
  IsPrivate?: Maybe<Scalars['Boolean']>;
  PrivateUrl?: Maybe<Scalars['String']>;
};


export type LoginResponse = {
  __typename?: 'LoginResponse';
  accessToken: Scalars['String'];
  user: UserEntity;
};

export type Mutation = {
  __typename?: 'Mutation';
  emailBlast: Scalars['Boolean'];
  createCurrency: CurrencyEntity;
  updateCurrency: CurrencyEntity;
  deleteCurrency: Scalars['Boolean'];
  Cur: CurrencyEntity;
  createCity: CityEntity;
  updateCity: CityEntity;
  deleteCity: Scalars['Boolean'];
  createCountry: CountryEntity;
  updateCountry: CountryEntity;
  deleteCountry: Scalars['Boolean'];
  createPostcode: PostcodeEntity;
  updatePostcode: PostcodeEntity;
  deletePostcode: Scalars['Boolean'];
  createState: StateEntity;
  updateState: StateEntity;
  deleteState: Scalars['Boolean'];
  updateAccount: AccountEntity;
  deleteAccount: Scalars['Boolean'];
  createAccount: AccountEntity;
  createSAccountSettings: SAccountSettings;
  updateAccountSettings: Scalars['Boolean'];
  updateSApiGateway: Scalars['Boolean'];
  createFromBankAccount: FromBankAccountEntity;
  updateFromBankAccount: FromBankAccountEntity;
  deleteFromBankAccount: Scalars['Boolean'];
  createUserActionLog: UserActionLogEntity;
  createRentXReportLog: ReportLogEntity;
  createReportLog: ReportLogEntity;
  createPackage: PackageEntity;
  updatePackage: PackageEntity;
  updateGateway: Scalars['Boolean'];
  deleteSNumberFormat: Scalars['Boolean'];
  updateSNumberFormat: Scalars['Boolean'];
  createSNumberFormat: SNumberFormat;
  deleteSoftware: Scalars['Boolean'];
  createSoftware: SoftwareEntity;
  updatesoftware: Scalars['Boolean'];
  createSubscription: SubscriptionEntity;
  updateSubscription: SubscriptionEntity;
  createTermsConditions: TermsConditionsEntity;
  updateTermsConditions: TermsConditionsEntity;
  updateUser: UserEntity;
  createUser: UserEntity;
  updateUserSoftwareAssignment: UserEntity;
  activateUser: Scalars['Boolean'];
  loginWithUsername: LoginResponse;
  login: LoginResponse;
  changePassword: UserEntity;
  logout: Scalars['Boolean'];
  forgotPassword: Scalars['Boolean'];
  resetPassword: Scalars['Boolean'];
  createAccUserSoftware: Scalars['Boolean'];
  totpSecret: Scalars['String'];
  totpValidate: Scalars['String'];
  createTenant: Scalars['Boolean'];
  syncUser: Scalars['String'];
  createTenantWithExistingEmail: Scalars['Boolean'];
  createTenantUserWithRole: Scalars['Boolean'];
  switchAccountDebtor: Scalars['String'];
  verifyAccessToken: Scalars['String'];
};


export type MutationEmailBlastArgs = {
  input: EmailBlastInput;
};


export type MutationCreateCurrencyArgs = {
  input: CurrencyInput;
};


export type MutationUpdateCurrencyArgs = {
  input: CurrencyInput;
};


export type MutationDeleteCurrencyArgs = {
  input: CurrencyDeleteInput;
};


export type MutationCurArgs = {
  input: CurrencyInput;
};


export type MutationCreateCityArgs = {
  input: CityInput;
};


export type MutationUpdateCityArgs = {
  input: CityInput;
};


export type MutationDeleteCityArgs = {
  input: CityInput;
};


export type MutationCreateCountryArgs = {
  input: CountryInput;
};


export type MutationUpdateCountryArgs = {
  input: CountryInput;
};


export type MutationDeleteCountryArgs = {
  input: CountryInput;
};


export type MutationCreatePostcodeArgs = {
  input: PostcodeInput;
};


export type MutationUpdatePostcodeArgs = {
  input: PostcodeInput;
};


export type MutationDeletePostcodeArgs = {
  input: PostcodeInput;
};


export type MutationCreateStateArgs = {
  input: StateInput;
};


export type MutationUpdateStateArgs = {
  input: StateInput;
};


export type MutationDeleteStateArgs = {
  input: StateInput;
};


export type MutationUpdateAccountArgs = {
  input: AccountInput;
};


export type MutationDeleteAccountArgs = {
  input: AccountDeleteInput;
};


export type MutationCreateAccountArgs = {
  input: AccountInput;
};


export type MutationCreateSAccountSettingsArgs = {
  settingValue: Scalars['String'];
  settingKey: Scalars['String'];
  accountID: Scalars['String'];
};


export type MutationUpdateAccountSettingsArgs = {
  settingValue: Scalars['String'];
  ID: Scalars['String'];
};


export type MutationUpdateSApiGatewayArgs = {
  callToken: Scalars['String'];
  gatewayUrl: Scalars['String'];
  gatewayID: Scalars['String'];
};


export type MutationCreateFromBankAccountArgs = {
  input: FromBankAccountInput;
};


export type MutationUpdateFromBankAccountArgs = {
  input: FromBankAccountInput;
};


export type MutationDeleteFromBankAccountArgs = {
  input: FromBankAccountInput;
};


export type MutationCreateUserActionLogArgs = {
  actionName: Scalars['String'];
  actionId: Scalars['String'];
};


export type MutationCreateRentXReportLogArgs = {
  path: Scalars['String'];
  reportName: Scalars['String'];
};


export type MutationCreateReportLogArgs = {
  input: ReportLogInput;
};


export type MutationCreatePackageArgs = {
  input: PackageInput;
};


export type MutationUpdatePackageArgs = {
  input: PackageInput;
};


export type MutationUpdateGatewayArgs = {
  accountId?: Maybe<Scalars['String']>;
  updateId: Scalars['String'];
};


export type MutationDeleteSNumberFormatArgs = {
  formatID: Scalars['String'];
};


export type MutationUpdateSNumberFormatArgs = {
  formatID: Scalars['String'];
  numberFormat: Scalars['String'];
  numberLength: Scalars['Float'];
};


export type MutationCreateSNumberFormatArgs = {
  numberFormat: Scalars['String'];
  accountId: Scalars['String'];
  numberLength: Scalars['Float'];
  numberTypeId: Scalars['String'];
};


export type MutationDeleteSoftwareArgs = {
  softwareID: Scalars['String'];
};


export type MutationCreateSoftwareArgs = {
  input: SoftwareInput;
};


export type MutationUpdatesoftwareArgs = {
  softwareID: Scalars['String'];
  input: SoftwareUpdateInput;
};


export type MutationCreateSubscriptionArgs = {
  input: SubscriptionInput;
};


export type MutationUpdateSubscriptionArgs = {
  input: SubscriptionUpdateInput;
};


export type MutationCreateTermsConditionsArgs = {
  input: TermsConditionsInput;
};


export type MutationUpdateTermsConditionsArgs = {
  input: TermsConditionsInput;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


export type MutationCreateUserArgs = {
  input: UserInput;
};


export type MutationUpdateUserSoftwareAssignmentArgs = {
  input: UpdateUserInput;
};


export type MutationActivateUserArgs = {
  token: Scalars['String'];
};


export type MutationLoginWithUsernameArgs = {
  SoftwareCode: SoftwareCode;
  Password: Scalars['String'];
  UserName: Scalars['String'];
};


export type MutationLoginArgs = {
  softwareCode: SoftwareCode;
  password: Scalars['String'];
  loginId: Scalars['String'];
};


export type MutationChangePasswordArgs = {
  newPassword: Scalars['String'];
  currentPassword: Scalars['String'];
};


export type MutationForgotPasswordArgs = {
  softwareCode: SoftwareCode;
  email: Scalars['String'];
};


export type MutationResetPasswordArgs = {
  password: Scalars['String'];
  token: Scalars['String'];
};


export type MutationCreateAccUserSoftwareArgs = {
  softwareID: Scalars['String'];
  accountID: Scalars['String'];
  userID: Scalars['String'];
};


export type MutationTotpValidateArgs = {
  token: Scalars['String'];
};


export type MutationCreateTenantArgs = {
  accountId: Scalars['String'];
  contractNo: Scalars['String'];
  debtorNo: Scalars['String'];
  userName: Scalars['String'];
  name: Scalars['String'];
  contactNo?: Maybe<Scalars['String']>;
  password: Scalars['String'];
};


export type MutationSyncUserArgs = {
  accountId: Scalars['String'];
};


export type MutationCreateTenantWithExistingEmailArgs = {
  contractNo: Scalars['String'];
  debtorNo: Scalars['String'];
  accountId: Scalars['String'];
  password: Scalars['String'];
  userEmail: Scalars['String'];
};


export type MutationCreateTenantUserWithRoleArgs = {
  input: CreateTenantUserAndRoleInput;
};


export type MutationSwitchAccountDebtorArgs = {
  debtorId: Scalars['Float'];
  accountId: Scalars['String'];
};


export type MutationVerifyAccessTokenArgs = {
  token: Scalars['String'];
};

export type NewsFeedEntity = CoreBaseEntity & {
  __typename?: 'NewsFeedEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  feedTitle: Scalars['String'];
  feedContent: Scalars['String'];
  feedStatus?: Maybe<Scalars['String']>;
  publishDate?: Maybe<Scalars['DateTime']>;
  accountId: Scalars['String'];
  hasExpiry?: Maybe<Scalars['Boolean']>;
  expiryDate?: Maybe<Scalars['DateTime']>;
  lPropertyId?: Maybe<Scalars['Float']>;
  isPostToAll?: Maybe<Scalars['Boolean']>;
  startDate?: Maybe<Scalars['DateTime']>;
  commonStatus: CommonStatus;
  account: AccountEntity;
  newsFeedReadStatus?: Maybe<NewsFeedReadStatusEntity>;
  attachment?: Maybe<AttachmentEntity>;
  createdByUser?: Maybe<UserEntity>;
};

export type NewsFeedReadStatusEntity = CoreBaseEntity & {
  __typename?: 'NewsFeedReadStatusEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  newsFeedId: Scalars['String'];
  commonStatus: CommonStatus;
  newsFeed?: Maybe<NewsFeedEntity>;
};

export type OnlineUserEntity = CoreBaseEntity & {
  __typename?: 'OnlineUserEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  commonStatus: Scalars['String'];
  userId: Scalars['String'];
  softwareId: Scalars['String'];
  accountId: Scalars['String'];
  entityId?: Maybe<Scalars['String']>;
  ipAddress?: Maybe<Scalars['String']>;
  lastLogin: Scalars['DateTime'];
  lastLogout?: Maybe<Scalars['DateTime']>;
  socketId?: Maybe<Scalars['String']>;
};

export type PackageEntity = CoreBaseEntity & {
  __typename?: 'PackageEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  name: Scalars['String'];
  softwareId: Scalars['String'];
  subscription: Array<SubscriptionEntity>;
  software: SoftwareEntity;
};

export type PackageInput = {
  ID?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  softwareId?: Maybe<Scalars['String']>;
};

export enum Permission {
  TenantAppNewsListingView = 'TENANT_APP_NEWS_LISTING__________VIEW',
  TenantAppNewsView = 'TENANT_APP_NEWS_____________VIEW',
  TenantAppRentalContractListingView = 'TENANT_APP_RENTAL_CONTRACT_LISTING__________VIEW',
  TenantAppRentalContractView = 'TENANT_APP_RENTAL_CONTRACT_____________VIEW',
  TenantAppAccountView = 'TENANT_APP_ACCOUNT_____________VIEW',
  TenantAppAccountListingView = 'TENANT_APP_ACCOUNT_LISTING__________VIEW',
  TenantAppAccountListingPayment = 'TENANT_APP_ACCOUNT_LISTING__________PAYMENT',
  TenantAppBillPaymentView = 'TENANT_APP_BILL_PAYMENT_____________VIEW',
  TenantAppBillPaymentListingView = 'TENANT_APP_BILL_PAYMENT_LISTING__________VIEW',
  TenantAppBillPaymentListingPayment = 'TENANT_APP_BILL_PAYMENT_LISTING__________PAYMENT',
  TenantAppBillingsView = 'TENANT_APP_BILLINGS_____________VIEW',
  TenantAppBillingsListingView = 'TENANT_APP_BILLINGS_LISTING__________VIEW',
  TenantAppMeterUtilityListingView = 'TENANT_APP_METER_UTILITY_LISTING__________VIEW',
  TenantAppMeterUtilityView = 'TENANT_APP_METER_UTILITY_____________VIEW',
  TenantAppServiceRequestView = 'TENANT_APP_SERVICE_REQUEST_____________VIEW',
  TenantAppServiceRequestListingView = 'TENANT_APP_SERVICE_REQUEST_LISTING__________VIEW',
  TenantAppServiceRequestListingCreate = 'TENANT_APP_SERVICE_REQUEST_LISTING__________CREATE',
  TenantAppServiceRequestListingCancel = 'TENANT_APP_SERVICE_REQUEST_LISTING__________CANCEL',
  TenantAppServiceRequestListingDetailQuotationView = 'TENANT_APP_SERVICE_REQUEST_LISTING_DETAIL_QUOTATION____VIEW',
  TenantAppServiceRequestListingDetailQuotationListingView = 'TENANT_APP_SERVICE_REQUEST_LISTING_DETAIL_QUOTATION_LISTING_VIEW',
  TenantAppServiceRequestListingDetailQuotationListingUpdate = 'TENANT_APP_SERVICE_REQUEST_LISTING_DETAIL_QUOTATION_LISTING_UPDATE',
  TenantAppServiceRequestListingDetailActivityLogView = 'TENANT_APP_SERVICE_REQUEST_LISTING_DETAIL_ACTIVITY_LOG____VIEW',
  TenantAppServiceRequestListingDetailActivityLogListingView = 'TENANT_APP_SERVICE_REQUEST_LISTING_DETAIL_ACTIVITY_LOG_LISTING_VIEW',
  TenantAppTenantSalesView = 'TENANT_APP_TENANT_SALES_____________VIEW',
  TenantAppTenantSalesListingView = 'TENANT_APP_TENANT_SALES_LISTING__________VIEW',
  TenantAppTenantSalesListingCreate = 'TENANT_APP_TENANT_SALES_LISTING__________CREATE',
  TenantAppTenantSalesListingSubmissionSubmit = 'TENANT_APP_TENANT_SALES_LISTING_SUBMISSION_______SUBMIT',
  TenantAppTenantSalesListingSubmissionDraft = 'TENANT_APP_TENANT_SALES_LISTING_SUBMISSION_______DRAFT',
  TenantAppTenantSalesListingSubmissionAddPos = 'TENANT_APP_TENANT_SALES_LISTING_SUBMISSION_______ADD_POS',
  TenantAppUserManagementView = 'TENANT_APP_USER_MANAGEMENT_____________VIEW',
  TenantAppUserManagementListingView = 'TENANT_APP_USER_MANAGEMENT_LISTING__________VIEW',
  TenantAppUserManagementListingUpdate = 'TENANT_APP_USER_MANAGEMENT_LISTING__________UPDATE',
  TenantAppUserManagementListingCreate = 'TENANT_APP_USER_MANAGEMENT_LISTING__________CREATE',
  WorkdeskNewsView = 'WORKDESK_NEWS_____________VIEW',
  WorkdeskNewsListingView = 'WORKDESK_NEWS_LISTING__________VIEW',
  WorkdeskNewsListingUpdate = 'WORKDESK_NEWS_LISTING__________UPDATE',
  WorkdeskNewsListingDelete = 'WORKDESK_NEWS_LISTING__________DELETE',
  WorkdeskNewsListingUpdateStatus = 'WORKDESK_NEWS_LISTING__________UPDATE_STATUS',
  WorkdeskNewsListingCreate = 'WORKDESK_NEWS_LISTING__________CREATE',
  WorkdeskNewsListingDetailDraft = 'WORKDESK_NEWS_LISTING_DETAIL_______DRAFT',
  WorkdeskNewsListingDetailPublish = 'WORKDESK_NEWS_LISTING_DETAIL_______PUBLISH',
  WorkdeskNewsListingDetailPostToAll = 'WORKDESK_NEWS_LISTING_DETAIL_______POST_TO_ALL',
  WorkdeskTodoView = 'WORKDESK_TODO_____________VIEW',
  WorkdeskNotificationView = 'WORKDESK_NOTIFICATION_____________VIEW',
  WorkdeskTodoListingView = 'WORKDESK_TODO_LISTING__________VIEW',
  WorkdeskNotificationListingView = 'WORKDESK_NOTIFICATION_LISTING__________VIEW',
  WorkdeskBusinessInsightView = 'WORKDESK_BUSINESS_INSIGHT_____________VIEW',
  WorkdeskBusinessInsightAgeingAnalysisView = 'WORKDESK_BUSINESS_INSIGHT_AGEING_ANALYSIS__________VIEW',
  WorkdeskBusinessInsightBookingStatisticsView = 'WORKDESK_BUSINESS_INSIGHT_BOOKING_STATISTICS__________VIEW',
  WorkdeskBusinessInsightOccupancyStatisticsView = 'WORKDESK_BUSINESS_INSIGHT_OCCUPANCY_STATISTICS__________VIEW',
  WorkdeskBusinessInsightContractOpportunityView = 'WORKDESK_BUSINESS_INSIGHT_CONTRACT_OPPORTUNITY__________VIEW',
  WorkdeskBusinessInsightNext_12MonthsOccupancyProjectionView = 'WORKDESK_BUSINESS_INSIGHT_NEXT_12_MONTHS_OCCUPANCY_PROJECTION__________VIEW',
  WorkdeskBusinessInsightRentalIncomeProjectionView = 'WORKDESK_BUSINESS_INSIGHT_RENTAL_INCOME_PROJECTION__________VIEW',
  WorkdeskBusinessInsightTenantSalesCollectionAnalysisView = 'WORKDESK_BUSINESS_INSIGHT_TENANT_SALES_COLLECTION_ANALYSIS__________VIEW',
  WorkdeskBusinessInsightTop_10RentalContributorView = 'WORKDESK_BUSINESS_INSIGHT_TOP_10_RENTAL_CONTRIBUTOR__________VIEW',
  WorkdeskBusinessInsightTop_10OutstandingView = 'WORKDESK_BUSINESS_INSIGHT_TOP_10_OUTSTANDING__________VIEW',
  WorkdeskBusinessInsightActiveContractReportView = 'WORKDESK_BUSINESS_INSIGHT_ACTIVE_CONTRACT_REPORT__________VIEW',
  WorkdeskBusinessInsightExpiringContractReportView = 'WORKDESK_BUSINESS_INSIGHT_EXPIRING_CONTRACT_REPORT__________VIEW',
  WorkdeskBusinessInsightDailySalesSubmissionReportView = 'WORKDESK_BUSINESS_INSIGHT_DAILY_SALES_SUBMISSION_REPORT__________VIEW',
  WorkdeskBusinessInsightServiceRequestReportView = 'WORKDESK_BUSINESS_INSIGHT_SERVICE_REQUEST_REPORT__________VIEW',
  WorkdeskBusinessInsightServiceRequestReportBiView = 'WORKDESK_BUSINESS_INSIGHT_SERVICE_REQUEST_REPORT_BI__________VIEW',
  WorkdeskBusinessInsightTenantPaymentTransactionsView = 'WORKDESK_BUSINESS_INSIGHT_TENANT_PAYMENT_TRANSACTIONS__________VIEW',
  WorkdeskBusinessInsightServiceRequestByAssigneeView = 'WORKDESK_BUSINESS_INSIGHT_SERVICE_REQUEST_BY_ASSIGNEE__________VIEW',
  WorkdeskBusinessInsightServiceRequestByMonthView = 'WORKDESK_BUSINESS_INSIGHT_SERVICE_REQUEST_BY_MONTH__________VIEW',
  OperationNewsView = 'OPERATION_NEWS_____________VIEW',
  OperationNewsListingView = 'OPERATION_NEWS_LISTING__________VIEW',
  OperationNewsListingUpdate = 'OPERATION_NEWS_LISTING__________UPDATE',
  OperationNewsListingDelete = 'OPERATION_NEWS_LISTING__________DELETE',
  OperationNewsListingUpdateStatus = 'OPERATION_NEWS_LISTING__________UPDATE_STATUS',
  OperationNewsListingCreate = 'OPERATION_NEWS_LISTING__________CREATE',
  OperationNewsListingDetailDraft = 'OPERATION_NEWS_LISTING_DETAIL_______DRAFT',
  OperationNewsListingDetailPublish = 'OPERATION_NEWS_LISTING_DETAIL_______PUBLISH',
  OperationNewsListingDetailPostToAll = 'OPERATION_NEWS_LISTING_DETAIL_______POST_TO_ALL',
  OperationMeterUtilityView = 'OPERATION_METER_UTILITY_____________VIEW',
  OperationMeterUtilityMeterTypeListingView = 'OPERATION_METER_UTILITY_METER_TYPE_LISTING_______VIEW',
  OperationMeterUtilityMeterTypeSubMeterView = 'OPERATION_METER_UTILITY_METER_TYPE_SUB_METER_______VIEW',
  OperationMeterUtilityMeterTypeMasterMeterView = 'OPERATION_METER_UTILITY_METER_TYPE_MASTER_METER_______VIEW',
  OperationMeterUtilityMeterTypeSubMeterListingView = 'OPERATION_METER_UTILITY_METER_TYPE_SUB_METER_LISTING____VIEW',
  OperationMeterUtilityMeterTypeMasterMeterListingView = 'OPERATION_METER_UTILITY_METER_TYPE_MASTER_METER_LISTING____VIEW',
  OperationMeterUtilityMeterTypeSubMeterListingMeterReadingCreate = 'OPERATION_METER_UTILITY_METER_TYPE_SUB_METER_LISTING_METER_READING_CREATE',
  OperationMeterUtilityMeterTypeMasterMeterListingMeterReadingCreate = 'OPERATION_METER_UTILITY_METER_TYPE_MASTER_METER_LISTING_METER_READING_CREATE',
  OperationServiceRequestView = 'OPERATION_SERVICE_REQUEST_____________VIEW',
  OperationServiceRequestListingView = 'OPERATION_SERVICE_REQUEST_LISTING__________VIEW',
  OperationServiceRequestListingCreate = 'OPERATION_SERVICE_REQUEST_LISTING__________CREATE',
  OperationServiceRequestListingDetailUpdate = 'OPERATION_SERVICE_REQUEST_LISTING_DETAIL_______UPDATE',
  OperationServiceRequestListingDetailQuotationView = 'OPERATION_SERVICE_REQUEST_LISTING_DETAIL_QUOTATION____VIEW',
  OperationServiceRequestListingDetailActivityLogView = 'OPERATION_SERVICE_REQUEST_LISTING_DETAIL_ACTIVITY_LOG____VIEW',
  OperationServiceRequestListingDetailQuotationListingView = 'OPERATION_SERVICE_REQUEST_LISTING_DETAIL_QUOTATION_LISTING_VIEW',
  OperationServiceRequestListingDetailActivityLogListingView = 'OPERATION_SERVICE_REQUEST_LISTING_DETAIL_ACTIVITY_LOG_LISTING_VIEW',
  OperationServiceRequestListingDetailActivityLogListingCreate = 'OPERATION_SERVICE_REQUEST_LISTING_DETAIL_ACTIVITY_LOG_LISTING_CREATE',
  OperationTenantSalesView = 'OPERATION_TENANT_SALES_____________VIEW',
  OperationTenantSalesSubmissionView = 'OPERATION_TENANT_SALES_SUBMISSION__________VIEW',
  OperationTenantSalesCollectionRecordView = 'OPERATION_TENANT_SALES_COLLECTION_RECORD__________VIEW',
  OperationTenantSalesSubmissionListingView = 'OPERATION_TENANT_SALES_SUBMISSION_LISTING_______VIEW',
  OperationTenantSalesSubmissionListingApprove = 'OPERATION_TENANT_SALES_SUBMISSION_LISTING_______APPROVE',
  OperationTenantSalesSubmissionListingCreate = 'OPERATION_TENANT_SALES_SUBMISSION_LISTING_______CREATE',
  OperationTenantSalesSubmissionListingReject = 'OPERATION_TENANT_SALES_SUBMISSION_LISTING_______REJECT',
  OperationTenantSalesSubmissionListingSubmissionSubmit = 'OPERATION_TENANT_SALES_SUBMISSION_LISTING_SUBMISSION____SUBMIT',
  OperationTenantSalesSubmissionListingSubmissionAddPos = 'OPERATION_TENANT_SALES_SUBMISSION_LISTING_SUBMISSION____ADD_POS',
  OperationTenantSalesCollectionRecordListingView = 'OPERATION_TENANT_SALES_COLLECTION_RECORD_LISTING_______VIEW',
  OperationRoutineInspectionView = 'OPERATION_ROUTINE_INSPECTION_____________VIEW',
  OperationRoutineInspectionListingView = 'OPERATION_ROUTINE_INSPECTION_LISTING__________VIEW',
  OperationRoutineInspectionListingCreate = 'OPERATION_ROUTINE_INSPECTION_LISTING__________CREATE',
  SystemAdminAccessSecurityView = 'SYSTEM_ADMIN_ACCESS_SECURITY_____________VIEW',
  SystemAdminAccessSecurityUserView = 'SYSTEM_ADMIN_ACCESS_SECURITY_USER__________VIEW',
  SystemAdminAccessSecurityRoleView = 'SYSTEM_ADMIN_ACCESS_SECURITY_ROLE__________VIEW',
  SystemAdminAccessSecurityRoleAssignmentView = 'SYSTEM_ADMIN_ACCESS_SECURITY_ROLE_ASSIGNMENT__________VIEW',
  SystemAdminAccessSecurityUserListingView = 'SYSTEM_ADMIN_ACCESS_SECURITY_USER_LISTING_______VIEW',
  SystemAdminAccessSecurityUserListingUpdateStatus = 'SYSTEM_ADMIN_ACCESS_SECURITY_USER_LISTING_______UPDATE_STATUS',
  SystemAdminAccessSecurityUserListingSyncUser = 'SYSTEM_ADMIN_ACCESS_SECURITY_USER_LISTING_______SYNC_USER',
  SystemAdminAccessSecurityRoleListingView = 'SYSTEM_ADMIN_ACCESS_SECURITY_ROLE_LISTING_______VIEW',
  SystemAdminAccessSecurityRoleListingUpdate = 'SYSTEM_ADMIN_ACCESS_SECURITY_ROLE_LISTING_______UPDATE',
  SystemAdminAccessSecurityRoleListingDelete = 'SYSTEM_ADMIN_ACCESS_SECURITY_ROLE_LISTING_______DELETE',
  SystemAdminAccessSecurityRoleListingCreate = 'SYSTEM_ADMIN_ACCESS_SECURITY_ROLE_LISTING_______CREATE',
  SystemAdminAccessSecurityRoleAssignmentDetailSubmit = 'SYSTEM_ADMIN_ACCESS_SECURITY_ROLE_ASSIGNMENT_DETAIL_______SUBMIT',
  SystemAdminTenantAccessSecurityView = 'SYSTEM_ADMIN_TENANT_ACCESS_SECURITY_____________VIEW',
  SystemAdminTenantAccessSecurityUserView = 'SYSTEM_ADMIN_TENANT_ACCESS_SECURITY_USER__________VIEW',
  SystemAdminTenantAccessSecurityUserListingView = 'SYSTEM_ADMIN_TENANT_ACCESS_SECURITY_USER_LISTING_______VIEW',
  SystemAdminTenantAccessSecurityRoleView = 'SYSTEM_ADMIN_TENANT_ACCESS_SECURITY_ROLE__________VIEW',
  SystemAdminTenantAccessSecurityRoleListingView = 'SYSTEM_ADMIN_TENANT_ACCESS_SECURITY_ROLE_LISTING_______VIEW',
  SystemAdminTenantAccessSecurityRoleListingUpdate = 'SYSTEM_ADMIN_TENANT_ACCESS_SECURITY_ROLE_LISTING_______UPDATE',
  SystemAdminTenantAccessSecurityRoleListingDelete = 'SYSTEM_ADMIN_TENANT_ACCESS_SECURITY_ROLE_LISTING_______DELETE',
  SystemAdminTenantAccessSecurityRoleListingCreate = 'SYSTEM_ADMIN_TENANT_ACCESS_SECURITY_ROLE_LISTING_______CREATE',
  SystemAdminDocumentNumberView = 'SYSTEM_ADMIN_DOCUMENT_NUMBER_____________VIEW',
  SystemAdminDocumentNumberListingView = 'SYSTEM_ADMIN_DOCUMENT_NUMBER_LISTING__________VIEW',
  SystemAdminDocumentNumberListingDetailUpdate = 'SYSTEM_ADMIN_DOCUMENT_NUMBER_LISTING_DETAIL_______UPDATE',
  SalesPropertyGalleryView = 'SALES_PROPERTY_GALLERY_____________VIEW',
  SalesOpportunityView = 'SALES_OPPORTUNITY_____________VIEW',
  SalesOpportunityListingView = 'SALES_OPPORTUNITY_LISTING__________VIEW',
  SalesOpportunityListingCreate = 'SALES_OPPORTUNITY_LISTING__________CREATE',
  SalesOpportunityListingDetailView = 'SALES_OPPORTUNITY_LISTING_DETAIL_______VIEW',
  SalesOpportunityListingDetailUpdate = 'SALES_OPPORTUNITY_LISTING_DETAIL_______UPDATE',
  SalesOpportunityListingActivityLogView = 'SALES_OPPORTUNITY_LISTING_ACTIVITY_LOG_______VIEW',
  SalesOpportunityListingLetterOfOfferView = 'SALES_OPPORTUNITY_LISTING_LETTER_OF_OFFER_______VIEW',
  SalesOpportunityListingBookingView = 'SALES_OPPORTUNITY_LISTING_BOOKING_______VIEW',
  SalesOpportunityListingOpportunityAssignmentView = 'SALES_OPPORTUNITY_LISTING_OPPORTUNITY_ASSIGNMENT_______VIEW',
  SalesOpportunityListingActivityLogListingCreate = 'SALES_OPPORTUNITY_LISTING_ACTIVITY_LOG_LISTING____CREATE',
  SalesOpportunityListingActivityLogListingView = 'SALES_OPPORTUNITY_LISTING_ACTIVITY_LOG_LISTING____VIEW',
  SalesOpportunityListingBookingListingView = 'SALES_OPPORTUNITY_LISTING_BOOKING_LISTING____VIEW',
  SalesOpportunityListingBookingListingCreate = 'SALES_OPPORTUNITY_LISTING_BOOKING_LISTING____CREATE',
  SalesOpportunityListingOpportunityAssignmentListingView = 'SALES_OPPORTUNITY_LISTING_OPPORTUNITY_ASSIGNMENT_LISTING____VIEW',
  SalesOpportunityListingOpportunityAssignmentListingCreate = 'SALES_OPPORTUNITY_LISTING_OPPORTUNITY_ASSIGNMENT_LISTING____CREATE',
  SalesOpportunityListingOpportunityAssignmentListingDelete = 'SALES_OPPORTUNITY_LISTING_OPPORTUNITY_ASSIGNMENT_LISTING____DELETE',
  SalesBookingView = 'SALES_BOOKING_____________VIEW',
  SalesBookingListingView = 'SALES_BOOKING_LISTING__________VIEW',
  SalesBookingListingCreate = 'SALES_BOOKING_LISTING__________CREATE',
  SalesRentalContractView = 'SALES_RENTAL_CONTRACT_____________VIEW',
  SalesRentalContractListingView = 'SALES_RENTAL_CONTRACT_LISTING__________VIEW'
}

export type PermissionRoleEntity = CoreBaseEntity & {
  __typename?: 'PermissionRoleEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  commonStatus: Scalars['String'];
  roleId: Scalars['String'];
  permissionId: Scalars['Float'];
  role: RoleEntity;
  permissionCode: Scalars['String'];
};

export type PostcodeEntity = CoreBaseEntity & {
  __typename?: 'PostcodeEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  postcode: Scalars['String'];
  cityId: Scalars['String'];
  commonStatus: CommonStatus;
  city: CityEntity;
};

export type PostcodeInput = {
  postcode?: Maybe<Scalars['String']>;
  cityID?: Maybe<Scalars['String']>;
  ID?: Maybe<Scalars['String']>;
};

export type PropertyOutput = {
  __typename?: 'PropertyOutput';
  propertyId?: Maybe<Scalars['Float']>;
  propertyNo?: Maybe<Scalars['String']>;
  propertyName?: Maybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  getCurrency: Array<CurrencyEntity>;
  getCurrencyByAccountId?: Maybe<AccountEntity>;
  getCitybyState: Array<CityEntity>;
  getCountry: Array<CountryEntity>;
  getPostcodebyCity: Array<PostcodeEntity>;
  getStatebyCountry: Array<StateEntity>;
  getAccount: Array<AccountEntity>;
  getAccountEntity: Array<AccountEntity>;
  getAccountSettings: Array<SAccountSettings>;
  getApiGatewayByAccount?: Maybe<Array<SApiGateway>>;
  getFromBankAccount: Array<FromBankAccountEntity>;
  getUserAccountInfo?: Maybe<CrossCallOutput>;
  getAccountInfo?: Maybe<CrossCallOutput>;
  getPackage: Array<PackageEntity>;
  getUpdate: SGatewayUpdates;
  getUpdates: Array<SGatewayUpdates>;
  getNumberFormat?: Maybe<Array<SNumberFormat>>;
  getAllSNumberFormat?: Maybe<Array<SNumberFormat>>;
  getNumberFormatByAcc?: Maybe<Array<SNumberFormat>>;
  getAllNumberType?: Maybe<Array<SNumberType>>;
  getSoftware: Array<SoftwareEntity>;
  getSubscription: Array<SubscriptionEntity>;
  getSubscriptionByAccountId: Array<SubscriptionEntity>;
  getTermsConditions: Array<TermsConditionsEntity>;
  getUser: Array<UserEntity>;
  loggedInUserProfile: UserEntity;
  activeUser: Scalars['Float'];
  getUsersByAccount: Array<UserEntity>;
  sendEmail: Scalars['Boolean'];
  getUsersbyIds: Array<UserEntity>;
  isUserValid: Scalars['Boolean'];
  getUsersBySoftware: Array<UserEntity>;
  validateAccountId: Scalars['Boolean'];
  getPermissionEnum: Scalars['Boolean'];
  isTenantUserEmailExist: Scalars['Boolean'];
  generateLeaseAppToken: Scalars['String'];
};


export type QueryGetCurrencyArgs = {
  orderByDesc?: Maybe<Scalars['String']>;
  orderByAsc?: Maybe<Scalars['String']>;
  skip?: Maybe<Scalars['Float']>;
  take?: Maybe<Scalars['Float']>;
  ID?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  symbol?: Maybe<Scalars['String']>;
};


export type QueryGetCurrencyByAccountIdArgs = {
  accountId?: Maybe<Scalars['String']>;
};


export type QueryGetCitybyStateArgs = {
  stateID: Scalars['String'];
};


export type QueryGetCountryArgs = {
  orderByDesc?: Maybe<Scalars['String']>;
  orderByAsc?: Maybe<Scalars['String']>;
  skip?: Maybe<Scalars['Float']>;
  take?: Maybe<Scalars['Float']>;
  ID?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};


export type QueryGetPostcodebyCityArgs = {
  cityID: Scalars['String'];
};


export type QueryGetStatebyCountryArgs = {
  countryID: Scalars['String'];
};


export type QueryGetAccountArgs = {
  orderByDesc?: Maybe<Scalars['String']>;
  orderByAsc?: Maybe<Scalars['String']>;
  skip?: Maybe<Scalars['Float']>;
  take?: Maybe<Scalars['Float']>;
  ID?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};


export type QueryGetAccountEntityArgs = {
  accountId?: Maybe<Scalars['String']>;
};


export type QueryGetAccountSettingsArgs = {
  settingKey?: Maybe<Scalars['String']>;
  ID?: Maybe<Scalars['String']>;
};


export type QueryGetApiGatewayByAccountArgs = {
  accountID: Scalars['String'];
};


export type QueryGetFromBankAccountArgs = {
  orderByDesc?: Maybe<Scalars['String']>;
  orderByAsc?: Maybe<Scalars['String']>;
  skip?: Maybe<Scalars['Float']>;
  take?: Maybe<Scalars['Float']>;
  ID?: Maybe<Scalars['String']>;
};


export type QueryGetPackageArgs = {
  orderByDesc?: Maybe<Scalars['String']>;
  orderByAsc?: Maybe<Scalars['String']>;
  skip?: Maybe<Scalars['Float']>;
  take?: Maybe<Scalars['Float']>;
  ID?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};


export type QueryGetUpdateArgs = {
  a: Scalars['String'];
  u: Scalars['String'];
};


export type QueryGetNumberFormatArgs = {
  ID: Scalars['String'];
};


export type QueryGetNumberFormatByAccArgs = {
  accountID: Scalars['String'];
  numberTypeId: Scalars['String'];
};


export type QueryGetSoftwareArgs = {
  orderByDesc?: Maybe<Scalars['String']>;
  orderByAsc?: Maybe<Scalars['String']>;
  skip?: Maybe<Scalars['Float']>;
  take?: Maybe<Scalars['Float']>;
  ID?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};


export type QueryGetSubscriptionArgs = {
  orderByDesc?: Maybe<Scalars['String']>;
  orderByAsc?: Maybe<Scalars['String']>;
  skip?: Maybe<Scalars['Float']>;
  take?: Maybe<Scalars['Float']>;
  ID?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};


export type QueryGetSubscriptionByAccountIdArgs = {
  accountId: Scalars['String'];
};


export type QueryGetTermsConditionsArgs = {
  orderByDesc?: Maybe<Scalars['String']>;
  orderByAsc?: Maybe<Scalars['String']>;
  skip?: Maybe<Scalars['Float']>;
  take?: Maybe<Scalars['Float']>;
  ID?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};


export type QueryGetUserArgs = {
  orderByDesc?: Maybe<Scalars['String']>;
  orderByAsc?: Maybe<Scalars['String']>;
  skip?: Maybe<Scalars['Float']>;
  take?: Maybe<Scalars['Float']>;
  ID?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  loginName?: Maybe<Scalars['String']>;
};


export type QueryGetUsersByAccountArgs = {
  activeUserOnly?: Maybe<Scalars['Boolean']>;
  accountID?: Maybe<Scalars['String']>;
};


export type QuerySendEmailArgs = {
  senderName: Scalars['String'];
  recipients: Array<Scalars['String']>;
  subject: Scalars['String'];
  message: Scalars['String'];
  isBodyHtml?: Maybe<Array<Scalars['String']>>;
  ccEmail?: Maybe<Array<Scalars['String']>>;
  bccEmail?: Maybe<Array<Scalars['String']>>;
};


export type QueryGetUsersbyIdsArgs = {
  userIDs: Array<Scalars['String']>;
};


export type QueryIsUserValidArgs = {
  userID: Scalars['String'];
};


export type QueryValidateAccountIdArgs = {
  AccountId: Scalars['String'];
};


export type QueryGetPermissionEnumArgs = {
  permission?: Maybe<Permission>;
};


export type QueryIsTenantUserEmailExistArgs = {
  contractNo: Scalars['String'];
  debtorNo: Scalars['String'];
  accountId: Scalars['String'];
  userEmail: Scalars['String'];
};


export type QueryGenerateLeaseAppTokenArgs = {
  softwareCode: SoftwareCode;
};

export type Recipient = {
  __typename?: 'Recipient';
  name?: Maybe<Scalars['String']>;
  email: Scalars['String'];
};

export type ReportLogEntity = {
  __typename?: 'ReportLogEntity';
  ID: Scalars['String'];
  accountId?: Maybe<Scalars['String']>;
  accountName?: Maybe<Scalars['String']>;
  softwareId?: Maybe<Scalars['String']>;
  softwareName?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
  reportName?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
  requestDate?: Maybe<Scalars['DateTime']>;
};

export type ReportLogInput = {
  accountId?: Maybe<Scalars['String']>;
  accountName?: Maybe<Scalars['String']>;
  softwareId?: Maybe<Scalars['String']>;
  softwareName?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
  reportName?: Maybe<Scalars['String']>;
  path?: Maybe<Scalars['String']>;
};

export type RequestActivity = CoreBaseEntity & {
  __typename?: 'RequestActivity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  assignId: Scalars['String'];
  tenantView: Scalars['Boolean'];
  remark?: Maybe<Scalars['String']>;
  commonStatus: CommonStatus;
  requestId: Scalars['String'];
  request: ServiceRequest;
  requestEstimation?: Maybe<RequestEstimation>;
  requestFollowUp?: Maybe<RequestFollowUp>;
  requestQuotation?: Maybe<RequestQuotation>;
  assignTo: UserEntity;
  attachment?: Maybe<Array<AttachmentEntity>>;
  numberOfAttachment?: Maybe<Scalars['Float']>;
  getLatestTwoRequestQuotation?: Maybe<RequestQuotation>;
  requestStatus?: Maybe<Scalars['String']>;
};

export type RequestEstimation = CoreBaseEntity & {
  __typename?: 'RequestEstimation';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  processDate?: Maybe<Scalars['DateTime']>;
  completeDate?: Maybe<Scalars['DateTime']>;
  durationDay?: Maybe<Scalars['Float']>;
  durationHour?: Maybe<Scalars['Float']>;
  commonStatus: CommonStatus;
  requestActivityId: Scalars['String'];
  requestActivity: RequestActivity;
  attachment?: Maybe<Array<AttachmentEntity>>;
  numberOfAttachment?: Maybe<Scalars['Float']>;
};

export type RequestFollowUp = CoreBaseEntity & {
  __typename?: 'RequestFollowUp';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  activityDate: Scalars['DateTime'];
  appointDate?: Maybe<Scalars['DateTime']>;
  commonStatus: CommonStatus;
  requestActivityId: Scalars['String'];
  requestActivity: RequestActivity;
  attachment?: Maybe<Array<AttachmentEntity>>;
  numberOfAttachment?: Maybe<Scalars['Float']>;
};

export type RequestLog = CoreBaseEntity & {
  __typename?: 'RequestLog';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  logTenant?: Maybe<Scalars['String']>;
  logMall?: Maybe<Scalars['String']>;
  isShow: Scalars['Boolean'];
  requestId: Scalars['String'];
  requestActivityId: Scalars['String'];
  commonStatus: CommonStatus;
  requestStatus: Scalars['String'];
  requestActivity?: Maybe<RequestActivity>;
  request: ServiceRequest;
};


export type RequestLogRequestActivityArgs = {
  TenantView?: Maybe<Scalars['Boolean']>;
};

export type RequestPublicArea = CoreBaseEntity & {
  __typename?: 'RequestPublicArea';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  accountId: Scalars['String'];
  name: Scalars['String'];
  defaulted: Scalars['Boolean'];
  seqNo: Scalars['Float'];
  requestOfPublicArea: Array<ServiceRequest>;
};

export type RequestQuotation = CoreBaseEntity & {
  __typename?: 'RequestQuotation';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  isProceed?: Maybe<Scalars['Boolean']>;
  reason?: Maybe<Scalars['String']>;
  operatorName?: Maybe<Scalars['String']>;
  operatorContactNo?: Maybe<Scalars['String']>;
  operatorEmail?: Maybe<Scalars['String']>;
  commonStatus: CommonStatus;
  requestActivityId: Scalars['String'];
  requestActivity: RequestActivity;
  attachment?: Maybe<AttachmentEntity>;
  numberOfAttachment?: Maybe<Scalars['Float']>;
};

export type RequestType = CoreBaseEntity & {
  __typename?: 'RequestType';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  accountId: Scalars['String'];
  name: Scalars['String'];
  defaulted: Scalars['Boolean'];
  seqNo: Scalars['Float'];
  requestOfType: Array<ServiceRequest>;
};

export type RoleEntity = CoreBaseEntity & {
  __typename?: 'RoleEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  commonStatus: Scalars['String'];
  accountId: Scalars['String'];
  softwareId: Scalars['String'];
  name: Scalars['String'];
  account: AccountEntity;
  software?: Maybe<SoftwareEntity>;
  permissions?: Maybe<Array<PermissionRoleEntity>>;
  totalPermission: Scalars['Float'];
  users?: Maybe<Array<UserEntity>>;
  roleUsers?: Maybe<Array<RoleUserEntity>>;
};


export type RoleEntityRoleUsersArgs = {
  isByUserId?: Maybe<Scalars['Boolean']>;
};

export type RoleUserEntity = CoreBaseEntity & {
  __typename?: 'RoleUserEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  commonStatus: Scalars['String'];
  accountId: Scalars['String'];
  entityId: Scalars['String'];
  roleId: Scalars['String'];
  userId: Scalars['String'];
  account: AccountEntity;
  role: RoleEntity;
  user: UserEntity;
};

export type SAccountSettings = CoreBaseEntity & {
  __typename?: 'SAccountSettings';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  settingKey: Scalars['String'];
  settingValue: Scalars['String'];
  accountId: Scalars['String'];
  account: AccountEntity;
};

export type SApiGateway = CoreBaseEntity & {
  __typename?: 'SApiGateway';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  apiGatewayUrl?: Maybe<Scalars['String']>;
  tokenValidity?: Maybe<Scalars['String']>;
  logoId?: Maybe<Scalars['String']>;
  apiCallToken?: Maybe<Scalars['String']>;
  adminUserId?: Maybe<Scalars['String']>;
  commonStatus: CommonStatus;
  accountId?: Maybe<Scalars['String']>;
  softwareId?: Maybe<Scalars['String']>;
  account?: Maybe<AccountEntity>;
  software?: Maybe<SoftwareEntity>;
  lease365ApiUrl?: Maybe<Scalars['String']>;
  lease365ApiToken?: Maybe<Scalars['String']>;
  lease365ApiTokenExpiresAt?: Maybe<Scalars['String']>;
};

export type SGatewayUpdates = CoreBaseEntity & {
  __typename?: 'SGatewayUpdates';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  version: Scalars['String'];
  md5: Scalars['String'];
  hasSqlUpdate: Scalars['Boolean'];
  url: Scalars['String'];
  verifySql?: Maybe<Scalars['String']>;
  sql?: Maybe<Scalars['String']>;
};

export type SNumberFormat = CoreBaseEntity & {
  __typename?: 'SNumberFormat';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  accountId: Scalars['String'];
  numberTypeId: Scalars['String'];
  numberFormat: Scalars['String'];
  numberLength: Scalars['Float'];
  commonStatus: CommonStatus;
  account: AccountEntity;
  numberType: SNumberType;
  sRunningNumberSetups: Array<SRunningNumberSetup>;
  prefixCode: Scalars['String'];
};

export type SNumberType = CoreBaseEntity & {
  __typename?: 'SNumberType';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  numberCode: Scalars['String'];
  numberName: Scalars['String'];
  commonStatus: CommonStatus;
  sNumberFormats: Array<SNumberFormat>;
};

export type SPaymentTransaction = CoreBaseEntity & {
  __typename?: 'SPaymentTransaction';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  commonStatus: Scalars['String'];
  accountId: Scalars['String'];
  transactionDate?: Maybe<Scalars['DateTime']>;
  amount: Scalars['Float'];
  paymentMethod?: Maybe<Scalars['String']>;
  referenceNo: Scalars['String'];
  status: Scalars['String'];
  response?: Maybe<Scalars['JSON']>;
  paymentProvider?: Maybe<Scalars['String']>;
  isPendingIntegration: Scalars['Boolean'];
  noOfRetry: Scalars['Float'];
  integrationError?: Maybe<Scalars['String']>;
  lDebtorId?: Maybe<Scalars['Float']>;
  account: AccountEntity;
  createdUser: UserEntity;
  isDeposit?: Maybe<Scalars['Boolean']>;
  transactionDetails?: Maybe<Array<SPaymentTransactionDetails>>;
};

export type SPaymentTransactionDetails = CoreBaseEntity & {
  __typename?: 'SPaymentTransactionDetails';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  sPaymentTransactionId: Scalars['String'];
  amount: Scalars['Float'];
  lBillId: Scalars['Float'];
  lDocumentNo: Scalars['String'];
  lBillItemName: Scalars['String'];
  lDocumentAmt: Scalars['Float'];
  lBalanceAmt?: Maybe<Scalars['Float']>;
  lChargeAmt?: Maybe<Scalars['Float']>;
  lTaxAmt?: Maybe<Scalars['Float']>;
  otherInfo?: Maybe<Scalars['JSON']>;
  transaction: SPaymentTransaction;
};

export type SRunningNumberSetup = CoreBaseEntity & {
  __typename?: 'SRunningNumberSetup';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  numberFormatId: Scalars['String'];
  accountId: Scalars['String'];
  nextNumber: Scalars['Float'];
  numberFormat: SNumberFormat;
};

export type ServiceDetail = CoreBaseEntity & {
  __typename?: 'ServiceDetail';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  message?: Maybe<Scalars['String']>;
  requestId?: Maybe<Scalars['String']>;
  commonStatus: CommonStatus;
  request: ServiceRequest;
  attachment?: Maybe<AttachmentEntity>;
};

export type ServiceDetailsMediaCount = {
  __typename?: 'ServiceDetailsMediaCount';
  ID?: Maybe<Scalars['String']>;
  textMediaCount?: Maybe<Scalars['Float']>;
  audioMediaCount?: Maybe<Scalars['Float']>;
  imageMediaCount?: Maybe<Scalars['Float']>;
  videoMediaCount?: Maybe<Scalars['Float']>;
};

export type ServiceRequest = CoreBaseEntity & {
  __typename?: 'ServiceRequest';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  lPropertyId: Scalars['Float'];
  lDebtorId?: Maybe<Scalars['Float']>;
  lUnitId?: Maybe<Scalars['Float']>;
  lastAssignId?: Maybe<Scalars['String']>;
  requestNo: Scalars['String'];
  requestStatus: Scalars['String'];
  publicAreaId?: Maybe<Scalars['String']>;
  requesterName: Scalars['String'];
  requesterContact?: Maybe<Scalars['String']>;
  requestTypeId?: Maybe<Scalars['String']>;
  requestTitle?: Maybe<Scalars['String']>;
  commonStatus: CommonStatus;
  accountId: Scalars['String'];
  isCancelled: Scalars['Boolean'];
  requestActivities?: Maybe<Array<RequestActivity>>;
  requestLogs: Array<RequestLog>;
  serviceDetails: Array<ServiceDetail>;
  account: AccountEntity;
  requestTypeData?: Maybe<RequestType>;
  publicAreaData?: Maybe<RequestPublicArea>;
  serviceDetailsMediaCount?: Maybe<ServiceDetailsMediaCount>;
  serviceRequestQuotationCount?: Maybe<ServiceRequestQuotationCount>;
  unitNo?: Maybe<Scalars['String']>;
  tenantName?: Maybe<Scalars['String']>;
  createdUser?: Maybe<UserEntity>;
  lastAssignTo?: Maybe<Scalars['String']>;
  getLatestTwoRequestQuotation?: Maybe<Array<RequestQuotation>>;
  nextFollowUpDate?: Maybe<Scalars['DateTime']>;
  ServiceRequestReport?: Maybe<Array<BusinessInsightOutput>>;
};


export type ServiceRequestRequestLogsArgs = {
  IsShow?: Maybe<Scalars['Boolean']>;
};

export type ServiceRequestQuotationCount = {
  __typename?: 'ServiceRequestQuotationCount';
  ID: Scalars['String'];
  quotationCount: Scalars['Float'];
};

export enum SoftwareCode {
  Contract = 'CONTRACT',
  Client = 'CLIENT',
  Subcontractor = 'SUBCONTRACTOR',
  Supplier = 'SUPPLIER',
  Hr = 'HR',
  Property = 'PROPERTY',
  Rent = 'RENT',
  Hotel = 'HOTEL',
  Account = 'ACCOUNT',
  User = 'USER',
  Tenant = 'TENANT',
  LeaseTodo = 'LEASE_TODO',
  LeaseOperation = 'LEASE_OPERATION',
  LeaseSales = 'LEASE_SALES',
  SystemAdmin = 'SYSTEM_ADMIN',
  LeaseApp = 'LEASE_APP'
}

export type SoftwareDelInput = {
  ID: Scalars['String'];
};

export type SoftwareEntity = CoreBaseEntity & {
  __typename?: 'SoftwareEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  name: Scalars['String'];
  code: Scalars['String'];
  supportEmail?: Maybe<Scalars['String']>;
  serviceHostUrl?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
  softwareAccount: UserAccSoftwareEntity;
  subscription: Array<SubscriptionEntity>;
  package: Array<PackageEntity>;
  termsConditions: Array<TermsConditionsEntity>;
  roles?: Maybe<Array<RoleEntity>>;
};

export type SoftwareInfo = {
  name: Scalars['String'];
  ID: Scalars['String'];
};

export type SoftwareInput = {
  name?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  supportEmail?: Maybe<Scalars['String']>;
  serviceHostUrl?: Maybe<Scalars['String']>;
  packages?: Maybe<Array<PackageInput>>;
};

export type SoftwareUpdateInput = {
  name?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  supportEmail?: Maybe<Scalars['String']>;
  serviceHostUrl?: Maybe<Scalars['String']>;
  packages?: Maybe<Array<PackageInput>>;
};

export type StateEntity = CoreBaseEntity & {
  __typename?: 'StateEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  name: Scalars['String'];
  countryId: Scalars['String'];
  commonStatus: CommonStatus;
  country: CountryEntity;
  city: Array<CityEntity>;
};

export type StateInput = {
  name?: Maybe<Scalars['String']>;
  countryID?: Maybe<Scalars['String']>;
  ID?: Maybe<Scalars['String']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  newLogins: OnlineUserEntity;
};

export type SubscriptionEntity = CoreBaseEntity & {
  __typename?: 'SubscriptionEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  accountId: Scalars['String'];
  packageId?: Maybe<Scalars['String']>;
  softwareId: Scalars['String'];
  subscriptionAmt: Scalars['Float'];
  salesOrderNo: Scalars['String'];
  remark: Scalars['String'];
  terminationReason?: Maybe<Scalars['String']>;
  isTerminated: Scalars['Boolean'];
  saleOrderDate: Scalars['DateTime'];
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  noOfUser: Scalars['Float'];
  entityControl?: Maybe<Scalars['JSON']>;
  commonStatus: CommonStatus;
  /** CustomFieldResolver */
  daysToGo: Scalars['Float'];
  account: AccountEntity;
  software: SoftwareEntity;
  package: PackageEntity;
};

export type SubscriptionInput = {
  accountId: Scalars['String'];
  softwareId: Scalars['String'];
  subscriptionAmt: Scalars['Float'];
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  noOfUser: Scalars['Float'];
  saleOrderDate: Scalars['DateTime'];
  salesOrderNo: Scalars['String'];
  remark?: Maybe<Scalars['String']>;
  entityControl: EntityContol;
};

export type SubscriptionUpdateInput = {
  ID?: Maybe<Scalars['String']>;
  accountId?: Maybe<Scalars['String']>;
  softwareId?: Maybe<Scalars['String']>;
  subscriptionAmt?: Maybe<Scalars['Float']>;
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  noOfUser?: Maybe<Scalars['Float']>;
  saleOrderDate?: Maybe<Scalars['DateTime']>;
  salesOrderNo?: Maybe<Scalars['String']>;
  remark?: Maybe<Scalars['String']>;
  entityControl?: Maybe<EntityContol>;
  terminationReason?: Maybe<Scalars['String']>;
  isTerminated?: Maybe<Scalars['Boolean']>;
};

export type TermsConditionsEntity = {
  __typename?: 'TermsConditionsEntity';
  name: Scalars['String'];
  softwareId: Scalars['String'];
  accountId?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  account: AccountEntity;
  software: SoftwareEntity;
};

export type TermsConditionsInput = {
  name: Scalars['String'];
  softwareId: Scalars['String'];
  accountId?: Maybe<Scalars['String']>;
  description: Scalars['String'];
};

export type TestPassword = CoreBaseEntity & {
  __typename?: 'TestPassword';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  name: Scalars['String'];
  password: Scalars['String'];
};

export type Unit = {
  __typename?: 'Unit';
  unitId?: Maybe<Scalars['Float']>;
  unitNo?: Maybe<Scalars['String']>;
};

export type UpdateAuditInput = {
  modBy?: Maybe<Scalars['String']>;
};

export type UpdateUserInput = {
  name?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  contactNo?: Maybe<Scalars['String']>;
  address?: Maybe<AddressInput>;
  isAdmin?: Maybe<Scalars['Boolean']>;
  superUser?: Maybe<Scalars['Boolean']>;
  avatar?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
  commonStatus?: Maybe<CommonStatus>;
  department?: Maybe<Scalars['String']>;
  jobTitle?: Maybe<Scalars['String']>;
  softwareInfo?: Maybe<Array<SoftwareInfo>>;
};

export type UserAccSoftwareEntity = CoreBaseEntity & {
  __typename?: 'UserAccSoftwareEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  userId: Scalars['String'];
  accountId: Scalars['String'];
  softwareId: Scalars['String'];
  tokenVersion?: Maybe<Scalars['Float']>;
  lUserId?: Maybe<Scalars['Float']>;
  lDebtorId?: Maybe<Scalars['Float']>;
  lCompanyId?: Maybe<Scalars['Float']>;
  accessToken?: Maybe<Scalars['String']>;
  refreshToken?: Maybe<Scalars['String']>;
  activatedDate?: Maybe<Scalars['DateTime']>;
  lastLogin?: Maybe<Scalars['DateTime']>;
  account: AccountEntity;
  user: UserEntity;
  software: SoftwareEntity;
};

export type UserActionLogEntity = {
  __typename?: 'UserActionLogEntity';
  ID: Scalars['String'];
  softwareId?: Maybe<Scalars['String']>;
  softwareName?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
  accountId?: Maybe<Scalars['String']>;
  accountName?: Maybe<Scalars['String']>;
  actionId?: Maybe<Scalars['String']>;
  actionName?: Maybe<Scalars['String']>;
  ipAddress?: Maybe<Scalars['String']>;
  loginDateTime?: Maybe<Scalars['DateTime']>;
};

export type UserCountSummary = {
  __typename?: 'UserCountSummary';
  totalActiveUser: Scalars['Float'];
  totalUser: Scalars['Float'];
};

export type UserEntity = CoreBaseEntity & {
  __typename?: 'UserEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  name: Scalars['String'];
  userName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  contactNo?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['JSON']>;
  department?: Maybe<Scalars['String']>;
  jobTitle?: Maybe<Scalars['String']>;
  accountId?: Maybe<Scalars['String']>;
  commonStatus: CommonStatus;
  confirmed: Scalars['Boolean'];
  avatar?: Maybe<Scalars['String']>;
  superUser: Scalars['Boolean'];
  pwdHistory?: Maybe<Scalars['JSON']>;
  is2FA: Scalars['Boolean'];
  totpSecret?: Maybe<Scalars['String']>;
  loginAttempt: Scalars['Float'];
  blockDuration: Scalars['Float'];
  blockCount: Scalars['Float'];
  loginTs?: Maybe<Scalars['DateTime']>;
  deviceIP?: Maybe<Scalars['String']>;
  softwareAccount: Array<UserAccSoftwareEntity>;
  roleUsers?: Maybe<Array<RoleUserEntity>>;
  paymentTransactions?: Maybe<Array<SPaymentTransaction>>;
  userNewsFeed?: Maybe<NewsFeedEntity>;
  account: Array<AccountEntity>;
  software: Array<SoftwareEntity>;
  tenantAccountName: Scalars['String'];
};

export type UserInput = {
  name: Scalars['String'];
  userName?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  contactNo: Scalars['String'];
  address?: Maybe<AddressInput>;
  department?: Maybe<Scalars['String']>;
  jobTitle?: Maybe<Scalars['String']>;
  commonStatus?: Maybe<CommonStatus>;
  superUser?: Maybe<Scalars['Boolean']>;
  avatar?: Maybe<Scalars['String']>;
  softwareInfo: Array<SoftwareInfo>;
};

export type UserOutput = {
  __typename?: 'UserOutput';
  userName?: Maybe<Scalars['String']>;
  handPhone?: Maybe<Scalars['String']>;
  remark?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  loginName?: Maybe<Scalars['String']>;
  companyData?: Maybe<CompanyData>;
  userId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['String']>;
};

export type LastAssignToOfServiceRequestDataLoaderInput = {
  __typename?: 'lastAssignToOfServiceRequestDataLoaderInput';
  lastAssignId: Scalars['Float'];
  accountId: Scalars['String'];
};

export type TenantNameOfServiceRequestDataLoaderInput = {
  __typename?: 'tenantNameOfServiceRequestDataLoaderInput';
  debtorId: Scalars['Float'];
  accountId: Scalars['String'];
};

export type UnitOfServiceRequestDataLoaderInput = {
  __typename?: 'unitOfServiceRequestDataLoaderInput';
  unitId: Scalars['Float'];
  accountId: Scalars['String'];
};

export type LoginMutationVariables = Exact<{
  Password: Scalars['String'];
  LoginId: Scalars['String'];
}>;


export type LoginMutation = (
  { __typename?: 'Mutation' }
  & { login: (
    { __typename?: 'LoginResponse' }
    & Pick<LoginResponse, 'accessToken'>
    & { user: (
      { __typename?: 'UserEntity' }
      & Pick<UserEntity, 'email' | 'ID' | 'name'>
    ) }
  ) }
);

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'logout'>
);

export type ChangePasswordMutationVariables = Exact<{
  NewPassword: Scalars['String'];
  CurrentPassword: Scalars['String'];
}>;


export type ChangePasswordMutation = (
  { __typename?: 'Mutation' }
  & { changePassword: (
    { __typename?: 'UserEntity' }
    & Pick<UserEntity, 'ID'>
  ) }
);

export type RequestForgotPasswordMutationVariables = Exact<{
  Email: Scalars['String'];
}>;


export type RequestForgotPasswordMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'forgotPassword'>
);

export type ResetPasswordMutationVariables = Exact<{
  Token: Scalars['String'];
  Password: Scalars['String'];
}>;


export type ResetPasswordMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'resetPassword'>
);

export type ValidateAccountIdQueryVariables = Exact<{
  AccountId: Scalars['String'];
}>;


export type ValidateAccountIdQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'validateAccountId'>
);

export type UserInfoQueryVariables = Exact<{
  UserId: Scalars['String'];
  ID?: Maybe<Scalars['String']>;
  settingKey?: Maybe<Scalars['String']>;
}>;


export type UserInfoQuery = (
  { __typename?: 'Query' }
  & { getUser: Array<(
    { __typename?: 'UserEntity' }
    & Pick<UserEntity, 'ID' | 'email' | 'name' | 'department'>
  )>, getAccountSettings: Array<(
    { __typename?: 'SAccountSettings' }
    & Pick<SAccountSettings, 'settingValue'>
  )>, getCurrencyByAccountId?: Maybe<(
    { __typename?: 'AccountEntity' }
    & { currency?: Maybe<(
      { __typename?: 'CurrencyEntity' }
      & Pick<CurrencyEntity, 'code' | 'symbol'>
    )> }
  )>, getUserAccountInfo?: Maybe<(
    { __typename?: 'CrossCallOutput' }
    & { account?: Maybe<(
      { __typename?: 'AccountOutput' }
      & Pick<AccountOutput, 'accountId' | 'name'>
    )>, property?: Maybe<(
      { __typename?: 'PropertyOutput' }
      & Pick<PropertyOutput, 'propertyNo' | 'propertyName' | 'propertyId'>
    )>, activeRentalContract?: Maybe<(
      { __typename?: 'ActiveRentalContract' }
      & Pick<ActiveRentalContract, 'IsHasGTO'>
    )> }
  )> }
);

export type CreateTenantMutationVariables = Exact<{
  AccountId: Scalars['String'];
  ContractNo: Scalars['String'];
  DebtorNo: Scalars['String'];
  UserName: Scalars['String'];
  Name: Scalars['String'];
  ContactNo?: Maybe<Scalars['String']>;
  Password: Scalars['String'];
}>;


export type CreateTenantMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'createTenant'>
);

export type ActivateUserMutationVariables = Exact<{
  Token: Scalars['String'];
}>;


export type ActivateUserMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'activateUser'>
);

export type GetPermissionEnumQueryVariables = Exact<{
  input?: Maybe<Permission>;
}>;


export type GetPermissionEnumQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'getPermissionEnum'>
);

export type SwitchAccountDebtorMutationVariables = Exact<{
  accountId: Scalars['String'];
  debtorId: Scalars['Float'];
}>;


export type SwitchAccountDebtorMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'switchAccountDebtor'>
);

export type VerifyTenantEmailExistQueryVariables = Exact<{
  accountId: Scalars['String'];
  contractNo: Scalars['String'];
  debtorNo: Scalars['String'];
  userEmail: Scalars['String'];
}>;


export type VerifyTenantEmailExistQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'isTenantUserEmailExist'>
);

export type CreateTenantWithExistingEmailMutationVariables = Exact<{
  accountId: Scalars['String'];
  contractNo: Scalars['String'];
  debtorNo: Scalars['String'];
  userEmail: Scalars['String'];
  password: Scalars['String'];
}>;


export type CreateTenantWithExistingEmailMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'createTenantWithExistingEmail'>
);

export type CreateUserMutationVariables = Exact<{
  input: CreateTenantUserAndRoleInput;
}>;


export type CreateUserMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'createTenantUserWithRole'>
);

export const LoginDocument = gql`
    mutation Login($Password: String!, $LoginId: String!) {
  login(softwareCode: TENANT, password: $Password, loginId: $LoginId) {
    accessToken
    user {
      email
      ID
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoginGQL extends Apollo.Mutation<LoginMutation, LoginMutationVariables> {
    document = LoginDocument;
    client = 'account';
  }
export const LogoutDocument = gql`
    mutation Logout {
  logout
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LogoutGQL extends Apollo.Mutation<LogoutMutation, LogoutMutationVariables> {
    document = LogoutDocument;
    client = 'account';
  }
export const ChangePasswordDocument = gql`
    mutation changePassword($NewPassword: String!, $CurrentPassword: String!) {
  changePassword(newPassword: $NewPassword, currentPassword: $CurrentPassword) {
    ID
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ChangePasswordGQL extends Apollo.Mutation<ChangePasswordMutation, ChangePasswordMutationVariables> {
    document = ChangePasswordDocument;
    client = 'account';
  }
export const RequestForgotPasswordDocument = gql`
    mutation RequestForgotPassword($Email: String!) {
  forgotPassword(softwareCode: TENANT, email: $Email)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RequestForgotPasswordGQL extends Apollo.Mutation<RequestForgotPasswordMutation, RequestForgotPasswordMutationVariables> {
    document = RequestForgotPasswordDocument;
    client = 'account';
  }
export const ResetPasswordDocument = gql`
    mutation ResetPassword($Token: String!, $Password: String!) {
  resetPassword(password: $Password, token: $Token)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ResetPasswordGQL extends Apollo.Mutation<ResetPasswordMutation, ResetPasswordMutationVariables> {
    document = ResetPasswordDocument;
    client = 'account';
  }
export const ValidateAccountIdDocument = gql`
    query ValidateAccountId($AccountId: String!) {
  validateAccountId(AccountId: $AccountId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ValidateAccountIdGQL extends Apollo.Query<ValidateAccountIdQuery, ValidateAccountIdQueryVariables> {
    document = ValidateAccountIdDocument;
    client = 'account';
  }
export const UserInfoDocument = gql`
    query UserInfo($UserId: String!, $ID: String, $settingKey: String) {
  getUser(ID: $UserId) {
    ID
    email
    name
    department
  }
  getAccountSettings(ID: $ID, settingKey: $settingKey) {
    settingValue
  }
  getCurrencyByAccountId(accountId: $ID) {
    currency {
      code
      symbol
    }
  }
  getUserAccountInfo {
    account {
      accountId
      name
    }
    property {
      propertyNo
      propertyName
      propertyId
    }
    activeRentalContract {
      IsHasGTO
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UserInfoGQL extends Apollo.Query<UserInfoQuery, UserInfoQueryVariables> {
    document = UserInfoDocument;
    client = 'account';
  }
export const CreateTenantDocument = gql`
    mutation CreateTenant($AccountId: String!, $ContractNo: String!, $DebtorNo: String!, $UserName: String!, $Name: String!, $ContactNo: String, $Password: String!) {
  createTenant(
    accountId: $AccountId
    contractNo: $ContractNo
    debtorNo: $DebtorNo
    userName: $UserName
    name: $Name
    contactNo: $ContactNo
    password: $Password
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateTenantGQL extends Apollo.Mutation<CreateTenantMutation, CreateTenantMutationVariables> {
    document = CreateTenantDocument;
    client = 'account';
  }
export const ActivateUserDocument = gql`
    mutation ActivateUser($Token: String!) {
  activateUser(token: $Token)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ActivateUserGQL extends Apollo.Mutation<ActivateUserMutation, ActivateUserMutationVariables> {
    document = ActivateUserDocument;
    client = 'account';
  }
export const GetPermissionEnumDocument = gql`
    query getPermissionEnum($input: Permission) {
  getPermissionEnum(permission: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPermissionEnumGQL extends Apollo.Query<GetPermissionEnumQuery, GetPermissionEnumQueryVariables> {
    document = GetPermissionEnumDocument;
    client = 'account';
  }
export const SwitchAccountDebtorDocument = gql`
    mutation switchAccountDebtor($accountId: String!, $debtorId: Float!) {
  switchAccountDebtor(accountId: $accountId, debtorId: $debtorId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SwitchAccountDebtorGQL extends Apollo.Mutation<SwitchAccountDebtorMutation, SwitchAccountDebtorMutationVariables> {
    document = SwitchAccountDebtorDocument;
    client = 'account';
  }
export const VerifyTenantEmailExistDocument = gql`
    query verifyTenantEmailExist($accountId: String!, $contractNo: String!, $debtorNo: String!, $userEmail: String!) {
  isTenantUserEmailExist(
    accountId: $accountId
    contractNo: $contractNo
    debtorNo: $debtorNo
    userEmail: $userEmail
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class VerifyTenantEmailExistGQL extends Apollo.Query<VerifyTenantEmailExistQuery, VerifyTenantEmailExistQueryVariables> {
    document = VerifyTenantEmailExistDocument;
    client = 'account';
  }
export const CreateTenantWithExistingEmailDocument = gql`
    mutation createTenantWithExistingEmail($accountId: String!, $contractNo: String!, $debtorNo: String!, $userEmail: String!, $password: String!) {
  createTenantWithExistingEmail(
    accountId: $accountId
    contractNo: $contractNo
    debtorNo: $debtorNo
    userEmail: $userEmail
    password: $password
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateTenantWithExistingEmailGQL extends Apollo.Mutation<CreateTenantWithExistingEmailMutation, CreateTenantWithExistingEmailMutationVariables> {
    document = CreateTenantWithExistingEmailDocument;
    client = 'account';
  }
export const CreateUserDocument = gql`
    mutation createUser($input: CreateTenantUserAndRoleInput!) {
  createTenantUserWithRole(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateUserGQL extends Apollo.Mutation<CreateUserMutation, CreateUserMutationVariables> {
    document = CreateUserDocument;
    client = 'account';
  }